import { render, staticRenderFns } from "./QuizFrom.vue?vue&type=template&id=67063dfb&scoped=true&"
import script from "./QuizFrom.vue?vue&type=script&lang=ts&"
export * from "./QuizFrom.vue?vue&type=script&lang=ts&"
import style0 from "./QuizFrom.vue?vue&type=style&index=0&id=67063dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67063dfb",
  null
  
)

export default component.exports